export const TAGS = {
  SUBSCRIPTION: "Subscription",
} as const;
